var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppLayout",
    {
      class: _vm.$page.props.staffView ? null : "container",
      attrs: {
        page: "/help-categories",
        pageTitle: "Search Results",
        tabs: true,
      },
      scopedSlots: _vm._u([
        {
          key: "tabs",
          fn: function () {
            return [
              _c("v-breadcrumbs", {
                staticClass: "px-1 py-3",
                attrs: { items: _vm.breadcrumbs },
              }),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c(
        "v-container",
        [
          _c(
            "v-row",
            { staticClass: "mb-4", attrs: { justify: "space-around" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "8", md: "6", lg: "4" } },
                [_c("Search", { attrs: { searchTerm: _vm.s } })],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-row",
            { attrs: { dense: "" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                _vm._l(_vm.articles, function (card, idx) {
                  return _c(
                    "v-card",
                    {
                      key: card.id,
                      staticClass: "soli-round",
                      attrs: { flat: "" },
                    },
                    [
                      _c(
                        "Link",
                        {
                          attrs: {
                            href: _vm.route("help-articles.show", card.id),
                          },
                        },
                        [
                          _c(
                            "v-card-title",
                            {
                              staticClass: "accent--text text-h5",
                              on: {
                                click: function ($event) {
                                  _vm.$inertia.visit(
                                    _vm.route("help-articles.show", card.id)
                                  )
                                },
                              },
                            },
                            [_vm._v(_vm._s(card.title))]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-card-subtitle",
                            {
                              staticClass: "soli-grey",
                              attrs: { title: card.updated_at },
                            },
                            [
                              _vm._v(
                                "Last updated\n                            " +
                                  _vm._s(card.updated_at_display)
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("v-card-text", {
                            staticClass: "soli-grey",
                            domProps: { innerHTML: _vm._s(card.excerpt) },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      idx !== _vm.articles.length - 1
                        ? _c("v-divider")
                        : _vm._e(),
                    ],
                    1
                  )
                }),
                1
              ),
              _vm._v(" "),
              _vm.articles.length == 0
                ? _c(
                    "v-col",
                    [
                      _c(
                        "v-card",
                        { staticClass: "soli-round" },
                        [
                          _c("v-card-text", [
                            _vm._v(
                              "\n                        No Help Articles matched your search terms.\n                    "
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }